import { isNumber } from "lodash";
import apiInstance from "./apiInstance";

const editUserIdentity = (params) => {
  const { identity, userId } = params;
  return apiInstance.put(`userv2/user/${userId}`, identity);
};

const editUserContact = (params) => {
  const { contact, userId } = params;
  return apiInstance.put(`userv2/user/adress/edit/${userId}`, contact);
};

const addUserContact = (params) => {
  const { address, userId } = params;
  return apiInstance.post(`userv2/user/adress/add/${userId}`, address);
};

const changeUserOwnPassword = (params) => {
  return apiInstance.put("/userv2/user/own/password", params);
};

const changeUserPassword = ({ userId, newPassword }) => {
  return apiInstance.put(`/userv2/user/password/${userId}/${newPassword}`);
};

const resetUsername = (userId) => {
  return apiInstance.put(`/userv2/user/username/${userId}`);
};

const editMultipleUserPhoneNumber = (params) => {
  return apiInstance.put(`userv2/user/phoneNumber/edit`, params);
};

const searchUser = (params) => {
  return apiInstance.post("/userv2/user/search", params);
};

const addNote = (params) => {
  return apiInstance.post("/user/note", params);
};

const addToDo = (params) => {
  return apiInstance.post("/user/todo", params);
};

const editToDo = (params) => {
  return apiInstance.put("/user/todo", params);
};

const deleteToDo = (params) => {
  return apiInstance.delete(`/user/todo/${params}`);
};

const searchTodo = (params) => {
  return apiInstance.post(`/user/todo/todo/search`, params);
};

const editNote = (params) => {
  return apiInstance.put(`/user/note`, params);
};

const deleteNote = (params) => {
  return apiInstance.delete(`/user/note/${params}`);
};

const searchNote = (params) => {
  return apiInstance.post(`/user/note/search`, params);
};

const generateTemporaryIdentityNumber = () => {
  return apiInstance.get("/userv2/user/temporary/identityNumber");
};

const changeUserRoleStatus = (params) => {
  const { status, userRoleId } = params;
  return apiInstance.put(`/userv2/user/${status}/${userRoleId}`);
};

const editUserOwnIdentity = (params) => {
  const { identity, userId } = params;
  return apiInstance.put(`/userv2/user/own/${userId}`, identity);
};

const checkUserName = (username) => {
  return apiInstance.put(`/userv2/user/userName/${username}`);
};

const changeUserName = ({ userId, newUserName }) => {
  return apiInstance.put(`/userv2/user/userName/${userId}/${newUserName}`);
};

const searchUserStudent = (params) => {
  return apiInstance.post(
    `/userv2/user/searchStudent?${isNumber(params?.status) ? `status=${params?.status}` : ""}`
  );
};

const getRoleOperationList = (roleId) => {
  return apiInstance.get(`/userv2/user/userRoleOperationList/${roleId}`);
};

const getUserRoles = (userId) => {
  return apiInstance.get(`/userv2/user/role/${userId}`);
};

const getUserByRoleId = (roleId) => {
  return apiInstance.get(`/userv2/user/getByRoleId/${roleId}`);
};

const searchUserStudentByGroupId = ({ termId, groupId }) => {
  return apiInstance.post(`/userv2/user/searchStudent/${termId}/${groupId}`);
};

const saveDashboard = (params) => {
  return apiInstance.post(`/userv2/user/dashboard`, params);
};

const getUserByRoleIds = (roleIds) => {
  return apiInstance.post(`/userv2/user/getByRoleIds`, roleIds);
};

const checkUserOwnPassword = (password) => {
  return apiInstance.get(`/userv2/user/check/own/password/${password}`);
};
const getMailsOfUser = (identityNumber) => {
  return apiInstance.post(`/forgotpassword/get-mails-of-user/${identityNumber}`);
};
const sendMailtoUserForPassword = (params) => {
  return apiInstance.post(`/forgotpassword/send-mail`, params);
};
const resetForgotPassword = (params) => {
  return apiInstance.post(`/forgotpassword/reset-password`, params);
};

const searchUserByText = (text) => {
  return apiInstance.post(`/userv2/user/searchUserByText/${text}`);
};

const searchUserByTextAndTermId = ({ text, termId }) => {
  return apiInstance.post(`/userv2/user/searchUserByText/${text}?termId=${termId}`);
};

const checkUserPasswordReset = (text) => {
  return apiInstance.get(`/userv2/user/checkPasswordReset`);
};

const deleteUserContact = (params) => {
  const { contactId, userId } = params;
  return apiInstance.delete(`userv2/user/adress/delete/${userId}/${contactId}`);
};

const checkUserPermission = (userId) => {
  return apiInstance.get(`/userv2/user/checkUserPermission/${userId}`);
};

const changeUserRoleBlockStatus = (params) => {
  return apiInstance.post(`/userv2/user/changeUserRoleBlock`, params);
};

const getFullNamesByPhoneNumberList = (params) => {
  const { schoolId, phoneNumbers } = params;
  return apiInstance.post(`/userv2/user/getFullNameByPhoneNumber/${schoolId}`, phoneNumbers);
};

const getUsersBirthDayToday = (params) => {
  let url = `/userv2/user/getTodayBornUsers/${params.termId}`;
  const queryParams = [];
  if (params.day !== undefined) queryParams.push(`day=${params.day}`);
  if (params.month !== undefined) queryParams.push(`month=${params.month}`);

  if (queryParams.length > 0) {
    url += `?${queryParams.join("&")}`;
  }

  return apiInstance.get(url);
};

const getTodayBornUsersForTeacher = (params) => {
  return apiInstance.get(`/userv2/user/getTodayBornUsersForTeacher`);
};

export {
  checkUserOwnPassword,
  editUserIdentity,
  editUserContact,
  addUserContact,
  changeUserPassword,
  searchUser,
  changeUserOwnPassword,
  getRoleOperationList,
  addNote,
  deleteNote,
  editNote,
  generateTemporaryIdentityNumber,
  searchNote,
  addToDo,
  editToDo,
  deleteToDo,
  searchTodo,
  changeUserRoleStatus,
  editUserOwnIdentity,
  checkUserName,
  changeUserName,
  searchUserStudent,
  getUserRoles,
  getUserByRoleId,
  searchUserStudentByGroupId,
  saveDashboard,
  getUserByRoleIds,
  getMailsOfUser,
  sendMailtoUserForPassword,
  resetForgotPassword,
  searchUserByText,
  editMultipleUserPhoneNumber,
  checkUserPasswordReset,
  deleteUserContact,
  checkUserPermission,
  resetUsername,
  searchUserByTextAndTermId,
  changeUserRoleBlockStatus,
  getFullNamesByPhoneNumberList,
  getUsersBirthDayToday,
  getTodayBornUsersForTeacher
};
